import React, { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from '../../../libs/yup/yup';
import Swal from 'sweetalert2';
import { Controller, useForm } from 'react-hook-form';
import CustomInput from '../../../components/input/CustomInput';
import { createCity, updateCity } from '../../../api/sportaloka-client';
import SelectProvince from '../../../components/input/SelectProvince';

const defaultValues = {
  name: '',
  province: null
};

const schema = yup.object().shape({
  name: yup.string().label('Nama kota').required('${label} wajib diisi'),
  province: yup
    .object()
    .label('Provinsi')
    .shape({
      label: yup.string().required(),
      value: yup.string().required()
    })
    .required('${label} wajib dipilih')
});

function UpdateCityModal({ onSubmitted, data }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) {
      setValue('name', data.name);
      setValue('province', { label: data.province.name, value: data.province.id });
    }
  }, [data]);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      await updateCity(data.id, val.name, val.province.value);
      Swal.fire({
        title: 'Berhasil!',
        text: 'Kota berhasil diperbarui',
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      reset();
      document.getElementById('closeModalUpdate').click();
      onSubmitted();
      setLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 409) {
        Swal.fire({
          title: 'Gagal!',
          text: `Kota '${val.name}' sudah ada di database`,
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      } else {
        Swal.fire({
          title: 'Gagal!',
          text: 'Periksa koneksi anda dan coba kembali.',
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleModalHidden = () => {
      reset();
    };

    const modalElement = document.getElementById('updateCityModal');
    modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }, [reset]);

  return (
    <div className="modal" tabIndex="-1" id="updateCityModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h5 className="modal-title">Edit Kota</h5>
              <button
                id="closeModalUpdate"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <Controller
                control={control}
                name="name"
                render={({ field: { onChange, onBlur, value } }) => (
                  <div className="mb-20">
                    <CustomInput
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      type="text"
                      label="Nama Kota"
                      isError={Boolean(errors.name)}
                      isSolid={true}
                      errorMessage={Boolean(errors.name) && errors.name.message}
                    />
                  </div>
                )}
              />
              <Controller
                control={control}
                name="province"
                render={({ field: { onChange, onBlur, value } }) => (
                  <div className="mb-20">
                    <SelectProvince
                      onChange={onChange}
                      onBlur={onBlur}
                      type="text"
                      label="Pilih Provinsi"
                      value={value}
                      isError={Boolean(errors.province)}
                      isSolid={true}
                      errorMessage={Boolean(errors.province) && errors.province.message}
                    />
                  </div>
                )}
              />
            </div>
            <div className="modal-footer justify-content-center">
              <button
                disabled={loading}
                type="submit"
                className="btn btn-primary bg-blue-1 rounded-1">
                <i className="fa fa-save mr-10"></i>
                <span className="fw-500">{loading ? 'Mohon tunggu...' : 'Simpan Perubahan'}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UpdateCityModal;
